import React, { useState } from 'react';
import { translate } from '@utils/i18n';
import { namespace as DeficiencyShowNamespace } from '@features/Deficiencies/DeficiencyShow/constants';
import { Button } from '@ui';
import { TextInput, TextArea } from '@ui/molecules/inputs/form/TextInput';
import { DateInput } from '@ui/molecules/inputs/form/DateInput';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ui/molecules/Modal';
import { ResolutionStatus } from '../ResolutionStatus';
const namespace = 'features.deficiencies.resolve_modal';
function ResolveModalForm({ resolutionValues, onSubmit, toggleDialog }) {
    const [formData, setFormData] = useState(resolutionValues);
    const clearForm = () => {
        toggleDialog();
        setFormData({
            deficiencyResolutionStatus: null,
            resolutionNotes: '',
            resolvedTechnicianName: '',
            dateResolved: null
        });
    };
    const handleTechnicianNameChange = (value) => {
        setFormData((prevState) => (Object.assign(Object.assign({}, prevState), { resolvedTechnicianName: value })));
    };
    const handleResolutionStatusChange = (newStatusId) => {
        setFormData((prevState) => (Object.assign(Object.assign({}, prevState), { deficiencyResolutionStatus: newStatusId })));
    };
    const handleDateChange = (value) => {
        setFormData((prevState) => (Object.assign(Object.assign({}, prevState), { dateResolved: value })));
    };
    const handleResolutionNotesChange = (value) => {
        setFormData((prevState) => (Object.assign(Object.assign({}, prevState), { resolutionNotes: value })));
    };
    const handleResolve = () => {
        void onSubmit({
            deficiencyResolutionStatus: formData.deficiencyResolutionStatus,
            resolutionNotes: formData.resolutionNotes,
            resolvedTechnicianName: formData.resolvedTechnicianName,
            dateResolved: formData.dateResolved
        });
        clearForm();
    };
    return (React.createElement(Modal, { isOpen: true, onClose: toggleDialog, ariaLabel: translate('title', { namespace }) },
        React.createElement(ModalHeader, { title: translate('title', { namespace }), onClose: toggleDialog }),
        React.createElement(ModalBody, null,
            React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '1.6rem' } },
                React.createElement(TextInput, { id: "resolvedTechnicianName", name: "resolvedTechnicianName", value: formData.resolvedTechnicianName, onChange: (e) => handleTechnicianNameChange(e.target.value), label: translate('resolved_technician_name', { namespace }), placeholder: " " }),
                React.createElement(ResolutionStatus, { initialValue: resolutionValues.deficiencyResolutionStatus, value: formData.deficiencyResolutionStatus, onChange: handleResolutionStatusChange, allowAddNew: true }),
                React.createElement(DateInput, { id: "dateResolved", name: "dateResolved", type: "date", value: formData.dateResolved, onChange: handleDateChange, label: translate('date_resolved', { namespace }), placeholder: " " }),
                React.createElement(TextArea, { id: "resolutionNotes", name: "resolutionNotes", value: formData.resolutionNotes, onChange: (e) => handleResolutionNotesChange(e.target.value), label: translate('resolution_notes', { namespace }), placeholder: " " }))),
        React.createElement(ModalFooter, null,
            React.createElement(Button, { onClick: clearForm }, translate('cancel', { namespace: 'generic' })),
            React.createElement(Button, { variant: "primary", onClick: handleResolve }, translate('resolve', { namespace: DeficiencyShowNamespace })))));
}
export default ResolveModalForm;
